var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "statementAfter" },
    [
      _c(
        "van-dialog",
        {
          attrs: { "show-confirm-button": false, "get-container": "#app" },
          model: {
            value: _vm.showStatementAfter,
            callback: function($$v) {
              _vm.showStatementAfter = $$v
            },
            expression: "showStatementAfter"
          }
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("平仓确认")]),
          _c("div", { staticClass: "centerbox_dialog" }, [
            _c("div", { staticClass: "flex orderInfo topCol" }, [
              _c("div", [_vm._v("平仓价格")]),
              _c("div", [_vm._v(_vm._s(_vm.hjPrice))])
            ]),
            _c(
              "div",
              { staticClass: "flex orderInfo topCol" },
              [
                _c("van-field", {
                  attrs: {
                    label: "平仓克重",
                    placeholder: "请输入平仓克重",
                    "input-align": "right",
                    size: "24px",
                    type: "number",
                    readonly: ""
                  },
                  model: {
                    value: _vm.weight,
                    callback: function($$v) {
                      _vm.weight = $$v
                    },
                    expression: "weight"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "flex popbtn" }, [
            _c(
              "div",
              { staticClass: "gocer closebtn", on: { click: _vm.close } },
              [_vm._v("取消")]
            ),
            _c(
              "div",
              { staticClass: "gocer confirmbtn", on: { click: _vm.confirm } },
              [_vm._v("确定")]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }